import { Vector3 } from 'three';
import { DEG2RAD } from 'three/src/math/MathUtils';

export default (distance, verticalAngleDeg, horizontalAngleDeg) => {
  if(verticalAngleDeg == 90) {
    // Allow using horizontal angle looking from (almost) straight up
    verticalAngleDeg = 89.9999;
  }
  return new Vector3().setFromSphericalCoords(distance, DEG2RAD * (90 - verticalAngleDeg), DEG2RAD * horizontalAngleDeg);
}
